 import React from 'react'
 
 // eslint-disable-next-line react/display-name
const Button = React.forwardRef(({ className, active, reversed,...props}, ref) => 
 (
 <span
   {...props}
   ref={ref}
   className={`${className} cursor-pointer  ${reversed ? active ? 'bg-white' : 'bg-gray-300' : active ? 'bg-gray-300' : ''}`}
 />
))




// eslint-disable-next-line react/display-name
const Icon = React.forwardRef(({ className, ...props }, ref) => (
 <span
 {...props}
 ref={ref}
 className={`${className} text-base align-text-bottom `}
/>
));

export {Button , Icon}